import * as ng from 'angular';

export const ExportComponent = {
  template: require('./export-component.html'),
  controller: class ExportComponentComponent {

    static $inject: string[] = [
      '$uibModal'
    ];

    private packageTypePrefix: string;
    private user: any;

    private packageTypes: any;
    private years: Array<number>;
    private months: Array<string>;

    private currentSelection: any;

    private resolve: any;
    private close: any;
    private dismiss: any;

    constructor(
      private $uibModal: ng.ui.bootstrap.IModalService,
    ) {
      this.packageTypes = [
        {id: 'PDF', label: 'Pacchetto PDF'},
        {id: 'XML', label: 'Pacchetto XML'}
      ];

      this.years = [...Array(10)].fill(new Date().getFullYear()).map((x, i) => x - i);
      this.months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

      this.currentSelection = this.getDefaultSelection();
    }

    $onInit(): void {
      this.packageTypePrefix = this.resolve.packageTypePrefix;
      this.user = this.resolve.user;
    }

    isFatturaPassiva(): boolean {
      return this.packageTypePrefix === 'FatturaPassiva';
    }

    cancel() {
      this.dismiss();
    }

    clearSelection() {
      this.currentSelection = this.getDefaultSelection();
    }

    updateDateField(field: string, value: Date) {
      console.log(`update ${field} ${value}`);
      this.currentSelection[field] = value;
    }

    export = () => {
      this.$uibModal.open({
        animation: true,
        component: 'workerFatturazioneGeneratePackagePRModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: {
            'PackageType': this.packageTypePrefix + '-' + this.currentSelection.selectedPackageTypeId,
            'year': this.currentSelection.selectedYear,
            'month': this.currentSelection.selectedMonthId,
            'user': this.user,
            'date_from': this.currentSelection.date_from,
            'date_to': this.currentSelection.date_to,
            'date_received_from': this.currentSelection.date_receive_from,
            'date_received_to': this.currentSelection.date_receive_to,
          }
        }
      });
      this.close({$value: this.currentSelection});
    };

    private getDefaultSelection = () => {
      const now = new Date();
      return {
        'selectedPackageTypeId': 'PDF',
        'selectedYear': now.getFullYear(),
        'selectedMonthId': now.getMonth()
      };
    };
  },
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/export-component/export-component.ts